const HondurasSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111588)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 39.9997C27.929 39.9997 34.7803 35.3852 38.0153 28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997Z"
        fill="#338AF3"
      />
      <path
        d="M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z"
        fill="#338AF3"
      />
      <path
        d="M12.3079 13.043L12.9554 15.0359H15.0508L13.3556 16.2674L14.0032 18.2603L12.3079 17.0287L10.6126 18.2603L11.2602 16.2674L9.56494 15.0359H11.6603L12.3079 13.043Z"
        fill="#338AF3"
      />
      <path
        d="M12.3079 21.7402L12.9554 23.7332H15.0508L13.3556 24.9648L14.0032 26.9576L12.3079 25.7259L10.6126 26.9576L11.2602 24.9648L9.56494 23.7332H11.6603L12.3079 21.7402Z"
        fill="#338AF3"
      />
      <path
        d="M27.6917 13.043L28.3393 15.0359H30.4347L28.7394 16.2674L29.387 18.2603L27.6917 17.0287L25.9964 18.2603L26.644 16.2674L24.9487 15.0359H27.0442L27.6917 13.043Z"
        fill="#338AF3"
      />
      <path
        d="M27.6917 21.7402L28.3393 23.7332H30.4347L28.7394 24.9648L29.387 26.9576L27.6917 25.7259L25.9964 26.9576L26.644 24.9648L24.9487 23.7332H27.0442L27.6917 21.7402Z"
        fill="#338AF3"
      />
      <path
        d="M19.9998 17.3916L20.6474 19.3846H22.7428L21.0475 20.6161L21.6951 22.6089L19.9998 21.3773L18.3045 22.6089L18.9521 20.6161L17.2568 19.3846H19.3522L19.9998 17.3916Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111588">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default HondurasSvg;
